export const SENTRY_CONSTANTS = {
  OWNERSHIP_TEAM: 'telus-abhealth-solutions',
};

export const DETAIL = {
  SAVE: 'save',
  AGREE_AND_CONTINUE: 'agree and continue',
  CONTINUE: 'continue',
  PREFERRED_NAME_UPDATED: 'preferred name updated',
  GENDER_IDENTITY_UPDATED: 'gender identity updated',
  SIGN_IN: 'sign in',
  CONTINUE_WITHOUT_SIGNING_IN: 'continue without signing in',
  CREATE_ACCOUNT: 'create account',
  CHANGE_PHOTO: 'change profile photo',
  ADD_PHOTO: 'add profile photo',
  EDIT_SETTINGS_LINK_OUT: 'edit settings link out',
  CANCEL: 'cancel',
  CONFIRM_DELETION: 'confirm deletion',
  ACKNOWLEDGE_DELETION: 'acknowledge deletion',
  START_HEALTH_ASSESSMENT: 'start health assessment',
  SKIP_HEALTH_ASSESSMENT: 'skip health assessment',
  PUSH_NOTIFICATIONS_TOGGLE: 'push notifications toggle',
  EDIT_EMAIL: 'edit email',
  NAVIGATE_TO_HOME: 'Navigate to Home page',
  NAVIGATE_TO_SERVICES: 'Navigate to Services page',
  NAVIGATE_TO_MY_HEALTH: 'Navigate to My Health page',
  CHANGE_ANNOUNCEMENT_OKAY: 'change announcement okay',
  CHANGE_ANNOUNCEMENT_GO_TO_MY_HEALTH: 'change announcement go to my health',
  CHANGE_ANNOUNCEMENT_DISMISS: 'change announcement dismiss',
};

export const ANALYTICS_SCREEN_NAMES = {
  PERSONAL_INFO: 'personal info',
  SIGN_IN: 'sign in',
  COMMUNICATION_PREFERENCES: 'communication preferences',
  BROWSE_HEALTH_TOPICS: 'browse health topic',
  PRIVACY_NOTICE: 'privacy notice',
  ABOUT_APP: 'about app overview',
  ERROR_SAVING_PERSONAL_INFO: 'error saving personal info',
  ERROR_UPLOADING_PHOTO_PHOTO: 'profile photo upload error',
  SEX_AND_GENDER_IDENTITY_INFO: 'sex and gender identity info',
  COMPLETE_ONBOARDING: 'complete onboarding',
  GENERIC_ERROR: 'generic error',
  DELETION_CONFIRMATION: 'deletion confirmation',
};

export const SUB_PRODUCT_AREA_NAMES = {
  FOOTER: 'footer',
  PERSONAL_INFO: 'personal info',
  SIGN_IN: 'sign in',
  ACCOUNT_SETUP: 'account setup',
  ONBOARDING: 'onboarding',
};

export const PRODUCT_AREA_NAMES = {
  HOME: 'home',
  FOUNDATION: 'foundation',
};
